export default "__VITE_ASSET__CRyIjEce__"